import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { findProduct } from "../data/products";

export default function ProductPlaceholderPage() {
  const { slug } = useParams();
  const product = findProduct(slug);

  if (!product) {
    return <Navigate to="/prodotti" replace />;
  }

  const { collection } = product;

  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to={collection.basePath}
        data-testid="product-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        Torna a {collection.section}
      </Link>

      <div
        data-testid="product-placeholder"
        className="grid md:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] gap-10 lg:gap-14 items-start"
      >
        {/* Cover */}
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_25px_80px_-20px_rgba(0,0,0,0.7)]">
            <img
              src={product.cover}
              alt={product.title}
              data-testid="product-cover"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>

        {/* Info */}
        <div>
          <div className="text-[11px] tracking-[0.32em] uppercase text-emerald-400/80 mb-4">
            {collection.section}
          </div>
          <h1
            data-testid="product-title"
            className="text-4xl sm:text-5xl font-extralight tracking-tight text-white leading-[1.05]"
          >
            {product.title}
          </h1>
          {product.subtitle && (
            <p className="mt-3 text-lg font-light text-white/60 leading-relaxed">
              {product.subtitle}
            </p>
          )}
          {product.author && (
            <p className="mt-6 text-[11px] tracking-[0.28em] uppercase text-white/40">
              di {product.author}
            </p>
          )}

          <div className="mt-10 glass-card p-8">
            <div className="text-[11px] tracking-[0.32em] uppercase text-emerald-400/70 mb-4">
              In arrivo
            </div>
            <p className="text-white/60 font-light leading-relaxed">
              La scheda completa di questo contenuto — descrizione, anteprima,
              prezzo e acquisto — sarà disponibile a breve. Nel frattempo la
              copertina è già parte della biblioteca TIME Inside.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
